import avatarPngW from "@/assets/gaiban/defaultAva-w.png";
import avatarPng from "@/assets/gaiban/defaultAva.png";
import detailButtonPng from "@/assets/gaiban/detailButton.png";
import editButtonPng from "@/assets/gaiban/editButton.png";
import deleteButtonPng from "@/assets/gaiban/deleteButton.png";
import detailButtonPngW from "@/assets/gaiban/detailButtonW.png";
import editButtonPngW from "@/assets/gaiban/editButtonW.png";
import deleteButtonPngW from "@/assets/gaiban/deleteButtonW.png";
import takeDownPngW from "@/assets/gaiban/takeDownW.png";
import takeDownPng from "@/assets/gaiban/takeDown.png";
import upPngW from "@/assets/gaiban/upW.png";
import upPng from "@/assets/gaiban/up.png";
import dianPng from "@/assets/gaiban/dian.png";
import dianPngW from "@/assets/gaiban/dianW.png";
import sendPng from "@/assets/gaiban/send.png";
import sendPngW from "@/assets/gaiban/sendW.png";
import closePng from "@/assets/gaiban/close.png";
import closePngW from "@/assets/gaiban/closeW.png";
import labelPng from "@/assets/gaiban/label.png";
import catePng from "@/assets/gaiban/cate.png";
import noOutPngW from "@/assets/gaiban/noOutW.png";
import noOutPng from "@/assets/gaiban/noOut.png";
import servicePng from "@/assets/gaiban/fuwu.png";
import servicePngW from "@/assets/gaiban/fuwuw.png";
import cdpzPng from "@/assets/gaiban/cdpz.png";
import cdpzPngW from "@/assets/gaiban/cdpzW.png";
import addCPng from "@/assets/gaiban/addC.png";
import addCPngW from "@/assets/gaiban/addCW.png";
import addPPng from "@/assets/gaiban/addP.png";
import addPPngW from "@/assets/gaiban/addPW.png";
import sjjlPng from "@/assets/gaiban/sjjl.png";
import sjjlPngW from "@/assets/gaiban/sjjlW.png";
import qyPng from "@/assets/gaiban/qy.png";
import qyPngW from "@/assets/gaiban/qyW.png";
import jyPng from "@/assets/gaiban/jy.png";
import jyPngW from "@/assets/gaiban/jyW.png";
import perPng from "@/assets/gaiban/per.png";
import perPngW from "@/assets/gaiban/perW.png";
import loadPng from "@/assets/gaiban/load.png";
import loadPngW from "@/assets/gaiban/loadW.png";
import loadcPng from "@/assets/gaiban/loadc.png";
import loadcPngW from "@/assets/gaiban/loadcW.png";
export default {
  namespaced: true,
  state: {
    persistData: {
      theme: "#409EFF",
      bgPage: "#202020",
      contentPage: "#121212",
      headerKuangPage: "#2d2d2d", //input框颜色
      style: {
        form: "searchForm-maomao",
        button: [
          "button_m_search",
          "button_m_reset",
          "button_m_addo",
          "button_m_moreo",
          "button_m_cancel",
        ],
        table: "table_maomao",
        avatar: avatarPngW,
        detailButton: detailButtonPng,
        editButton: editButtonPng,
        deleteButton: deleteButtonPng,
        normalTextColor: "normalTextColorClass",
        dianButton: dianPng,
        sendButton: sendPng,
        closeImg: closePng,
        labelImg: labelPng,
        cateImg: catePng,
        xiajiaButton: takeDownPng,
        shangjiaButton: upPng,
        fuwuButton: servicePng,
        cdpzButton: cdpzPng,
        addCButton: addCPng,
        addPButton: addPPng,
        sjjlButton: sjjlPng,
        qiyongButton: qyPng,
        jinyongButton: jyPng,
        quanxianButton: perPng,
        loadButton: loadPng,
        loadcButton: loadcPng,
        menuBg: "1",
      },
    },
  },
  getters: {
    currentTheme: (state) => {
      return state.persistData.theme;
    },
    currentbgPageTheme: (state) => {
      return state.persistData.bgPage;
    },
    currenContentPageTheme: (state) => {
      return state.persistData.contentPage;
    },
    currenHeaderKuangPageTheme: (state) => {
      return state.persistData.headerKuangPage;
    },
    currentStyleTheme: (state) => {
      return state.persistData.style;
    },
  },
  mutations: {
    changeTheme(state, theme) {
      localStorage.setItem("theme", theme);
      state.persistData.theme = theme;
    },
    changeBgPageTheme(state, theme) {
      localStorage.setItem("bgPageTheme", theme);
      state.persistData.bgPage = theme;
    },
    changeContentPageTheme(state, theme) {
      localStorage.setItem("contentPageTheme", theme);
      state.persistData.contentPage = theme;
    },
    changeHeaderKuangPageTheme(state, theme) {
      localStorage.setItem("headerKuangPageTheme", theme);
      state.persistData.headerKuangPage = theme;
    },
    changeStyleTheme(state, theme) {
      console.log("mutationschangeStyleTheme" + theme);
      localStorage.setItem("m-style", theme);
      if (theme + "" === "1") {
        state.persistData.style = {
          form: "searchForm-maomao",
          button: [
            "button_m_search",
            "button_m_reset",
            "button_m_addo",
            "button_m_moreo",
            "button_m_cancel",
          ],
          table: "table_maomao",
          avatar: avatarPngW,
          detailButton: detailButtonPng,
          editButton: editButtonPng,
          deleteButton: deleteButtonPng,
          normalTextColor: "normalTextColorClass",
          dianButton: dianPng,
          sendButton: sendPng,
          closeImg: closePng,
          labelImg: labelPng,
          cateImg: catePng,
          xiajiaButton: takeDownPng,
          shangjiaButton: upPng,
          noOutButton: noOutPng,
          fuwuButton: servicePng,
          cdpzButton: cdpzPng,
          addCButton: addCPng,
          addPButton: addPPng,
          sjjlButton: sjjlPng,
          qiyongButton: qyPng,
          jinyongButton: jyPng,
          quanxianButton: perPng,
          loadButton: loadPng,
          loadcButton: loadcPng,
          menuBg: "1",
        };
      } else if (theme + "" === "2") {
        state.persistData.style = {
          form: "searchForm-maomao-1",
          button: [
            "button_m_search",
            "button_m_reset",
            "button_m_addo",
            "button_m_moreo",
            "button_m_cancel",
          ],
          table: "table_maomao_1",
          avatar: avatarPng,
          detailButton: detailButtonPngW,
          editButton: editButtonPngW,
          deleteButton: deleteButtonPngW,
          normalTextColor: "normalTextColorClassW",
          dianButton: dianPngW,
          sendButton: sendPngW,
          closeImg: closePngW,
          labelImg: labelPng,
          cateImg: catePng,
          menuBg: "2",
          xiajiaButton: takeDownPngW,
          noOutButton: noOutPngW,
          shangjiaButton: upPngW,
          fuwuButton: servicePngW,
          addCButton: addCPngW,
          cdpzButton: cdpzPngW,
          addPButton: addPPngW,
          sjjlButton: sjjlPngW,
          qiyongButton: qyPngW,
          jinyongButton: jyPngW,
          quanxianButton: perPngW,
          loadButton: loadPngW,
          loadcButton: loadcPngW,
        };
      } else {
        state.persistData.style = {
          form: "searchForm-maomao-2",
          button: [
            "button_m_search2",
            "button_m_reset2",
            "button_m_addo2",
            "button_m_moreo2",
            "button_m_cancel2",
          ],
          table: "table_maomao_2",
        };
      }

      console.log(
        "mutationschangeStyleTheme结果个" +
          JSON.stringify(state.persistData.style)
      );
    },
  },
  actions: {
    changeTheme({ commit }, theme) {
      localStorage.setItem("theme", theme);
      commit("changeTheme", theme);
    },
    changeBgPageTheme({ commit }, theme) {
      localStorage.setItem("bgPageTheme", theme);
      commit("changeBgPageTheme", theme);
    },
    changeContentPageTheme({ commit }, theme) {
      localStorage.setItem("contentPageTheme", theme);
      commit("changeContentPageTheme", theme);
    },
    changeHeaderKuangPageTheme({ commit }, theme) {
      localStorage.setItem("headerKuangPageTheme", theme);
      commit("changeHeaderKuangPageTheme", theme);
    },
    changeStyleTheme({ commit }, theme) {
      console.log("actionschangeStyleTheme" + theme);
      localStorage.setItem("m-style", theme);
      commit("changeStyleTheme", theme);
    },
  },
};
